/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
import { useAutopayContext } from '../../contexts/AutopayContext';
import Styles from '../../css/CancelAutopayModal.module.css';

const CancelAutopayModal = () => {
  const autopayContext = useAutopayContext();

  return (
    <DefaultModal
      open={autopayContext.cancelAutopayModalOpen}
      onClose={() => autopayContext.setCancelAutopayModalOpen(false)}
      title={<h1 className={Styles.title}>Attention</h1>}
      content={
        <p className={Styles.message}>
          You are trying to to cancel the autopay set up for your loan. Please click on the Confirm button to Cancel the
          Autopay.
        </p>
      }
      footer={
        <div className={Styles.footer}>
          <div className={Styles.flexRow}>
            <Button
              variant='outlined'
              onClick={() => autopayContext.setCancelAutopayModalOpen(false)}
              className={Styles.cancelButton}
            >
              Back
            </Button>
            <Button variant='contained' onClick={() => autopayContext.handleCancel()} className={Styles.button}>
              Confirm
            </Button>
          </div>
          <p className={Styles.note}>
            {'Once the auto pay is cancelled your monthly payment will not be drafted from your bank account. You will be responsible' +
              ' to make the monthly payments in the month they are due. If the payment is not received in the month they are due it may' +
              ' result in late charges and negative credit reporting.'}
          </p>
        </div>
      }
    />
  );
};

export default CancelAutopayModal;
